import { Controller } from "@hotwired/stimulus"

/**
 * CV Builder preview panel controller.
 * Scales the A4-sized preview to fit its container and
 * preserves scroll position across Turbo Frame updates.
 */
export default class extends Controller {
  static targets = ["page"]

  connect() {
    this._scrollTop = 0
    this._resizeObserver = new ResizeObserver(() => this._scale())
    this._resizeObserver.observe(this.element)
    this._scale()
  }

  disconnect() {
    this._resizeObserver?.disconnect()
  }

  // Called before Turbo replaces the frame content
  preserveScroll() {
    this._scrollTop = this.element.scrollTop
  }

  // Called after Turbo replaces the frame content
  restoreScroll() {
    this._scale()
    this.element.scrollTop = this._scrollTop
  }

  _scale() {
    if (!this.hasPageTarget) return

    const page = this.pageTarget
    const containerWidth = this.element.clientWidth - 32 // account for padding
    const pageWidth = page.offsetWidth

    if (pageWidth > 0 && containerWidth < pageWidth) {
      const scale = containerWidth / pageWidth
      page.style.transform = `scale(${scale})`
      page.style.transformOrigin = "top left"
      page.style.marginBottom = `${-(pageWidth - containerWidth) * (page.offsetHeight / pageWidth)}px`
    } else {
      page.style.transform = ""
      page.style.marginBottom = ""
    }
  }
}
